import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../shared/types';
import Swal from 'sweetalert2';

interface ErrorDetail {
  title: string;
  text: string;
}

export const handleError = (error: AxiosError<AxiosCommonError>) => {
  const errorMessage = error.response?.data.message || error.response?.data.errorMessage;

  const errorDetails: { [key: string]: ErrorDetail } = {
    // -- 로그인 에러 메세지
    '등록되지 않은 E-MAIL 입니다.': {
      title: 'E-MAIL 오류',
      text: '등록되지 않은 E-MAIL 입니다',
    },
    '잘못된 비밀번호입니다.': {
      title: '비밀번호 오류',
      text: '잘못된 비밀번호입니다.',
    },
    '승인되지 않은 계정입니다.': {
      title: '계정 승인 오류',
      text: '승인되지 않은 계정입니다. 관리자에게 문의 바랍니다.',
    },
    '중복된 이메일이 존재합니다.': {
      title: '중복 이메일 오류',
      text: '중복된 이메일이 존재합니다.',
    },
    '중복된 와이파이 맥번호가 존재합니다.': {
      title: '중복 오류',
      text: '중복된 와이파이 맥번호가 존재합니다.',
    },
    '중복된 이더넷 맥번호가 존재합니다.': {
      title: '중복 오류',
      text: '중복된 이더넷 맥번호가 존재합니다.',
    },
    '이미 등록된 사업자번호입니다.': {
      title: '중복 오류',
      text: '이미 등록된 사업자번호입니다.',
    },
    // 거래처 관련
    MODLINK_PROJECT_USED_ERR: {
      title: '모드링크 프로젝트 사용중',
      text: '프로젝트에 연결된 모드링크가 있어 삭제할 수 없습니다.',
    },
    PASSWORD_DISCREPANCY_ERR: {
      title: '기존 비밀번호 불일치',
      text: '비밀번호가 일치하지 않습니다.',
    },
    MAC_FOUND_ERR: {
      title: '이미 등록된 MAC',
      text: '다른 프로젝트에 등록된 MAC입니다.',
    },
    MQTT_TIMEOUT: {
      title: '디바이스 응답이 지연되었습니다.',
      text: '디바이스와 연결이 끊겼습니다.',
    },
    MQTT_REQUEST_ERR: {
      title: '디바이스에 요청 중 오류 발생',
      text: '디바이스에 요청 중 예상치 못한 오류가 발생했습니다.',
    },
    SLAVEID_FOUND_ERR: {
      title: 'Slave ID 중복',
      text: '입력하신 Slave ID가 이미 등록되어 있습니다.<br>Slave ID 확인 후 다시 시도해주세요.',
    },
    CANNOT_ADD_MORE_SLAVES: {
      title: 'Slave 추가 실패',
      text: 'Slave 추가는 최대 8개까지 가능합니다.',
    },
    NODE_REGISTERED_FOR_ANALYSIS: {
      title: '데이터 삭제 실패',
      text: '분석 데이터에 포함된 노드가 있어 삭제할 수 없습니다.',
    },
    MODLINK_INITIALIZATION_REQUIRED_ERR: {
      title: '모드링크 초기화 실패',
      text: '모드링크 초기화에 실패하였습니다.',
    },
    CANNOT_ADD_MORE_NODES_T2: {
      title: '노드 추가 실패',
      text: '노드 추가는 최대 35개까지 가능합니다.',
    },
    CANNOT_ADD_MORE_NODES_L: {
      title: '노드 추가 실패',
      text: '노드 추가는 최대 50개까지 가능합니다.',
    },
    MAC_ALREADY_EXIST: {
      title: 'MAC 중복',
      text: '입력하신 MAC은 이미 등록되어 있습니다.',
    },

    // -- company
    err_invalid_name_format: {
      title: '이름 형식 오류',
      text: '이름 형식이 올바르지 않습니다.',
    },
    err_invalid_phone_format: {
      title: '전화번호 형식 오류',
      text: '전화번호는 숫자만 입력 가능합니다.',
    },
    err_invalid_representative_format: {
      title: '대표자명 형식 오류',
      text: '대표자명 형식이 올바르지 않습니다.',
    },

    // -- user
    err_invalid_email_format: {
      title: '이메일 형식 오류',
      text: '이메일 형식이 올바르지 않습니다.',
    },

    err_registered_service_in_use: {
      title: '디바이스 사용 중',
      text: '해당 디바이스는 현재 사용 중이므로 수정/삭제할 수 없습니다.',
    },
    err_password_mismatch: {
      title: '비밀번호 불일치',
      text: '비밀번호가 일치하지 않습니다.',
    },
    err_mac_required: {
      title: 'MAC 번호 누락',
      text: 'MAC 번호를 입력해주세요.',
    },
    err_device_cd_required: {
      title: '디바이스 종류 누락',
      text: '디바이스 종류를 선택해주세요.',
    },
    err_serial_num_required: {
      title: 'S/N 누락',
      text: 'S/N을 입력해주세요.',
    },
    err_network_type_required: {
      title: '네트워크 종류 누락',
      text: '네트워크 종류를 선택해주세요.',
    },
    err_distributor_company_required: {
      title: '납품처 누락',
      text: '납품처를 입력해주세요.',
    },
    err_invalid_network_type: {
      title: '네트워크 종류 오류',
      text: '네트워크 종류가 올바르지 않습니다.',
    },
    err_modem_required: {
      title: '모뎀 누락',
      text: '모뎀을 입력해주세요.',
    },
    err_modem_no_required: {
      title: '모뎀 번호 누락',
      text: '모뎀 번호를 입력해주세요.',
    },
    err_status_yn_required: {
      title: '모뎀 상태 누락',
      text: '모뎀 상태를 선택해주세요.',
    },
    err_modem_already_assigned: {
      title: '모뎀 할당 오류',
      text: '이미 다른 디바이스에 할당된 모뎀입니다.',
    },
    err_duplicate_korean_role_name: {
      title: '등록 불가 안내',
      text: '이미 존재하는 국문 역할명입니다. 중복되지 않는 국문 역할명으로 수정 바랍니다.',
    },
    err_duplicate_english_role_name: {
      title: '등록 불가 안내',
      text: '이미 존재하는 영문 역할명입니다. 중복되지 않는 영문 역할명으로 수정 바랍니다.',
    },
    err_permission_already_in_use: {
      title: '삭제 불가 안내',
      text: '해당 계정으로 등록된 하위 계정이 있습니다. 하위 계정이 존재하는 경우 삭제가 불가합니다.',
    },
    err_manual_learning_not_completed: {
      title: '파일 적용 불가',
      text: '학습이 완료되기 전에는 파일을 적용할 수 없습니다.',
    },
    AI_SERVICE_CHANNEL_NOT_ENABLED: {
      title: 'MachineGPT 서비스 미사용',
      text: 'MachineGPT 서비스가 활성화되지 않은 계정입니다. 관리자에게 문의 바랍니다.',
    },
  };

  if (typeof errorMessage === 'string' && errorMessage in errorDetails) {
    const errorInfo = errorDetails[errorMessage];

    Swal.fire({
      title: errorInfo.title,
      text: errorInfo.text,
      icon: 'error',
      confirmButtonText: '확인',
    });
  } else {
    Swal.fire({
      title: '알 수 없는 에러 발생',
      text: '알 수 없는 에러가 발생했습니다.',
      icon: 'error',
      confirmButtonText: '확인',
    });
  }
};
